import React from 'react'
import ClipboardCopy from './clipboardcopy'
import AirdropCountdown from './airdropcountdown'
import AppContext from '../context/appContext'
import { useContext } from 'react'

const UserHome = () => {

    const appContext = useContext(AppContext)

    const { authToken, createAccount, setAuthToken, getUser, userData } = appContext
    console.log(userData);

    return (
        <div>
            <div className="px-md-5">
                <h1 className="text-light">User Dashboard</h1>
            </div>
           
            <div className="mt-4">
                <span className="h4 text-light px-md-5">User Refferal Code</span>

                <ClipboardCopy referralLink={`https://vertexchain.world/sign-up/${userData.walletAddress}`} />
            </div>
            <AirdropCountdown />

            <div className="container-fluid pt-3 pb-5">
                <div className="px-md-5">

                    <div data-aos="fade-up" data-aos-duration="1000" className="row">
                        <div className="col-sm-6 col-lg-4 col-12 my-2">
                            <div class="card h-100 rounded-4 overflow-hidden" style={{ borderColor: "#fff", backgroundColor: "#23153c" }}>
                                {/* <img src="..." class="card-img-top" alt="..."/> */}
                                <div className='px-3 pb-3 pt-4' style={{ borderRadius: '100%' }}>
                                    <p className='display-3 h1 text-light' style={{ fontWeight: "bold" }}>{userData.referrals.length}</p>
                                </div>
                                <div class="card-body d-flex flex-column">
                                    <h2 class="card-title text-light">Referrals                                   </h2>
                                    <p class="card-text text-light">The total number of referred users by your referral link</p>

                                </div>
                            </div>
                        </div>
                        <div className="col-sm-6 col-lg-4 col-12 my-2">
                            <div class="card h-100 rounded-4 overflow-hidden" style={{ borderColor: "#fff", backgroundColor: "#23153c" }}>
                                {/* <img src="..." class="card-img-top" alt="..."/> */}
                                <div className='px-3 pb-3 pt-4' style={{ borderRadius: '100%' }}>
                                    <p className='display-3 h1 text-light' style={{ fontWeight: "bold" }}>{`$${Math.floor(userData.referralBonus * 1000) / 1000}`}</p>
                                </div>
                                <div class="card-body d-flex flex-column">
                                    <h2 class="card-title text-light">      Referrals Earnings                             </h2>
                                    <p class="card-text text-light">Total amount of earnings by total referred users</p>

                                </div>
                            </div>
                        </div>
                        <div className="col-sm-6 col-lg-4 col-12 my-2">
                            <div class="card h-100 rounded-4 overflow-hidden" style={{ borderColor: "#fff", backgroundColor: "#23153c" }}>
                                {/* <img src="..." class="card-img-top" alt="..."/> */}
                                <div className='px-3 pb-3 pt-4' style={{ borderRadius: '100%' }}>
                                    <p className='display-3 h1 text-light' style={{ fontWeight: "bold" }}>{`$${userData.level>4?1000:userData.level<4?100:500}`}</p>
                                </div>
                                <div class="card-body d-flex flex-column">
                                    <h2 class="card-title text-light">Total Staking</h2>
                                    <p class="card-text text-light">The total amount of funds that are staked to receive monthly staking reward</p>

                                </div>
                            </div>
                        </div>
                        <div className="col-sm-6 col-lg-4 col-12 my-2">
                            <div class="card h-100 rounded-4 overflow-hidden" style={{ borderColor: "#fff", backgroundColor: "#23153c" }}>
                                {/* <img src="..." class="card-img-top" alt="..."/> */}
                                <div className='px-3 pb-3 pt-4' style={{ borderRadius: '100%' }}>
                                    <p className='display-3 h1 text-light' style={{ fontWeight: "bold" }}>{`$${Math.floor(userData.stakingAmount * 1000) / 1000}`}</p>
                                </div>
                                <div class="card-body d-flex flex-column">
                                    <h2 class="card-title text-light">Staking Rewards</h2>
                                    <p class="card-text text-light">Total staking reward earned according to your current level</p>

                                </div>
                            </div>
                        </div>

                        <div className="col-sm-6 col-lg-4 col-12 my-2">
                            <div class="card h-100 rounded-4 overflow-hidden" style={{ borderColor: "#fff", backgroundColor: "#23153c" }}>
                                {/* <img src="..." class="card-img-top" alt="..."/> */}
                                <div className='px-3 pb-3 pt-4' style={{ borderRadius: '100%' }}>
                                    <p className='display-3 h1 text-light' style={{ fontWeight: "bold" }}>{`$${Math.floor(userData.totalAmount * 1000) / 1000}`}</p>
                                </div>
                                <div class="card-body d-flex flex-column">
                                    <h2 class="card-title text-light">Total Earnings</h2>
                                    <p class="card-text text-light">Total earning which consist of staking reward, referral earnings, and transfers received</p>

                                </div>
                            </div>
                        </div>
                        <div className="col-sm-6 col-lg-4 col-12 my-2">
                            <div class="card h-100 rounded-4 overflow-hidden" style={{ borderColor: "#23153c", backgroundColor: "#fff" }}>
                                {/* <img src="..." class="card-img-top" alt="..."/> */}
                                <div className='px-3 pb-3 pt-4' style={{ borderRadius: '100%' }}>
                                    <p className='display-3 h1 ' style={{ fontWeight: "bold" }}>{`$${Math.floor(userData.currentUserBalance * 1000) / 1000}`}</p>
                                </div>
                                <div class="card-body d-flex flex-column">
                                    <h2 class="card-title">Current Balance</h2>
                                    <p class="card-text ">Your current balance after excluding transfers and withdraws</p>

                                </div>
                            </div>
                        </div>




                    </div>
                </div>
            </div>
        </div>
    )
}

export default UserHome




// <div className="col-sm-6 col-lg-4 col-12 my-2">
// <div  class="card h-100 rounded-4 overflow-hidden" style={{ borderColor: "#fff", backgroundColor: "#23153c" }}>
//     {/* <img src="..." class="card-img-top" alt="..."/> */}
//     <div className='px-3 pb-3 pt-4' style={{ borderRadius: '100%' }}>
//         <p className='display-3 h1 text-light' style={{ fontWeight: "bold" }}>{`${userData.withdrawlAmount}$`}</p>
//     </div>
//     <div class="card-body d-flex flex-column">
//         <h2 class="card-title text-light">Withdraws</h2>
//         <p class="card-text text-light">Fully audited smart contract with zero human intervention</p>

//     </div>
// </div>
// </div>
// <div className="col-sm-6 col-lg-4 col-12 my-2">
// <div  class="card h-100 rounded-4 overflow-hidden" style={{ borderColor: "#fff", backgroundColor: "#23153c" }}>
//     {/* <img src="..." class="card-img-top" alt="..."/> */}
//     <div className='px-3 pb-3 pt-4' style={{ borderRadius: '100%' }}>
//         <p className='display-3 h1 text-light' style={{ fontWeight: "bold" }}>{`${userData.totalTransfer}$`}</p>
//     </div>
//     <div class="card-body d-flex flex-column">
//         <h2 class="card-title text-light">Transfers</h2>
//         <p class="card-text text-light">Fully audited smart contract with zero human intervention</p>

//     </div>
// </div>
// </div>